// import React, { useState } from "react";
// import {
//   Grid,
//   Paper,
//   Box,
//   MenuItem,
//   TextField,
//   Typography,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
// } from "@mui/material";
// import ButtonComp from "../../../../components/Button";
// import Input from "../../../../components/Input";
// import { useCaseCreationStore } from "../../../../store/useCaseCreationStore";
// import { useRelationOptions } from "../../../../hooks/useRelationOptions";
// import theme from "../../../../theme";

// export default function DeceasedDetails({ onNext, onBack }: any) {
//   const [errors, setErrors] = useState<Record<string, string>>({});

//   const { deceasedDetails, setDeceasedDetails } = useCaseCreationStore();
//   const { relationOptions, loading } = useRelationOptions();

//   const validateSouthAfricanID = (id: string): string | null => {
//     // must be 13 digits
//     if (!/^\d{13}$/.test(id)) return "ID number must be 13 digits";

//     // Extract parts
//     const dob = id.substring(0, 6);
//     const ssss = parseInt(id.substring(6, 10), 10);
//     const citizenship = parseInt(id.charAt(10), 10);
//     const checkDigit = id.charAt(12);

//     // Validate DOB
//     const year = parseInt(dob.substring(0, 2), 10);
//     const month = parseInt(dob.substring(2, 4), 10);
//     const day = parseInt(dob.substring(4, 6), 10);
//     const fullYear = year < 50 ? 2000 + year : 1900 + year;

//     const date = new Date(fullYear, month - 1, day);
//     if (
//       date.getFullYear() !== fullYear ||
//       date.getMonth() + 1 !== month ||
//       date.getDate() !== day
//     ) {
//       return "Invalid date of birth in ID number";
//     }

//     // Validate gender sequence
//     if (ssss < 0 || ssss > 9999) {
//       return "Invalid gender sequence in ID number";
//     }

//     // Validate citizenship
//     if (![0, 1, 2].includes(citizenship)) {
//       return "Invalid citizenship digit in ID number";
//     }

//     // Luhn checksum
//     const luhnCheck = (num: string) => {
//       let sum = 0;
//       let alt = false;
//       for (let i = num.length - 1; i >= 0; i--) {
//         let n = parseInt(num.charAt(i), 10);
//         if (alt) {
//           n *= 2;
//           if (n > 9) n -= 9;
//         }
//         sum += n;
//         alt = !alt;
//       }
//       return sum % 10 === 0;
//     };

//     if (!luhnCheck(id)) return "Invalid ID number checksum";

//     return null; // ✅ Valid
//   };

//  const validateForm = () => {
//     const newErrors: Record<string, string> = {};

//     if (!deceasedDetails.title) newErrors.title = "Title is required";

//     if (!deceasedDetails.initials)
//       newErrors.initials = "Initials are required";

//     if (!deceasedDetails.firstName)
//       newErrors.firstName = "First name is required";

//     if (!deceasedDetails.lastName)
//       newErrors.lastName = "Last name is required";

//     if (!deceasedDetails.dateOfBirth) 
//       newErrors.dateOfBirth = "Date of birth is required";

//     if (!deceasedDetails.dateOfDeath)
//       newErrors.dateOfDeath = "Date of death is required";

//     if (!deceasedDetails.causeOfDeath)
//       newErrors.causeOfDeath = "Cause of death is required";

//     if (!deceasedDetails.relationship)
//       newErrors.relationship = "Relationship is required";

//     if (!deceasedDetails.identificationType)
//       newErrors.identificationType = "Select ID or Passport";

//     if (!deceasedDetails.identificationNumber)
//       newErrors.identificationNumber = "Identification number is required";
  

//     setErrors(newErrors);

//     return Object.keys(newErrors).length === 0;
//   };

// const handleNextClick = () => {
//     const isValid = validateForm();

//     if (!isValid) return;

//     onNext();
//   };

//    const clearError = (field: string) => {
//     setErrors((prev) => {
//       const updated = { ...prev };
//       delete updated[field];
//       return updated;
//     });
//   };

//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         p: 4,
//         mt: 3,
//         borderRadius: 3,
//         backgroundColor: "#fff",
//       }}
//     >
//       <Grid container spacing={3}>
//         <Grid size={{ xs: 12, md: 6 }}>
//           <Input
//             fullWidth
//             label="Title *"
//             value={deceasedDetails.title}
//             onChange={(e: any) => {
//               setDeceasedDetails({ title: e.target.value });
//               clearError("title");
//             }}
//             error={Boolean(errors.title)}
//             helperText={errors.title}
//           />
//         </Grid>
//         <Grid size={{ xs: 12, md: 6 }}>
//           <Input
//             fullWidth
//             label="Initials *"
//             value={deceasedDetails.initials}
//             onChange={(e: any) => {
//               setDeceasedDetails({ initials: e.target.value });
//               clearError("initials");
//             }}
//              error={Boolean(errors.initials)}
//             helperText={errors.initials}
//           />
//         </Grid>
//         <Grid size={{ xs: 12, md: 6 }}>
//           <Input
//             fullWidth
//             label="First Name *"
//             value={deceasedDetails.firstName}
//             onChange={(e: any) => {
//               setDeceasedDetails({ firstName: e.target.value });
//               clearError("firstName");
//             }}
//             error={Boolean(errors.firstName)}
//             helperText={errors.firstName}
//           />
//         </Grid>

//         <Grid size={{ xs: 12, md: 6 }}>
//           <Input
//             fullWidth
//             label="Last Name *"
//             value={deceasedDetails.lastName}
//             onChange={(e: any) => {
//               setDeceasedDetails({ lastName: e.target.value });
//               clearError("lastName");
//             }}
//             error={Boolean(errors.lastName)}
//             helperText={errors.lastName}
//           />
//         </Grid>

//         <Grid size={{ xs: 12, md: 4 }}>
//           <Input
//             fullWidth
//             type="date"
//             label="Date of Birth *"
//             InputLabelProps={{ shrink: true }}
//             value={deceasedDetails.dateOfBirth}
//             onChange={(e: any) => {
//               setDeceasedDetails({ dateOfBirth: e.target.value });
//               clearError("dateOfBirth");
//             }}
//             error={Boolean(errors.dateOfBirth)}
//             helperText={errors.dateOfBirth}
//           />
//         </Grid>

//         <Grid size={{ xs: 12, md: 4 }}>
//           <Input
//             fullWidth
//             type="date"
//             label="Date of Death *"
//             InputLabelProps={{ shrink: true }}
//             value={deceasedDetails.dateOfDeath}
//             onChange={(e: any) => {
//               setDeceasedDetails({ dateOfDeath: e.target.value });
//               clearError("dateOfDeath");
//             }}
//             error={Boolean(errors.dateOfDeath)}
//             helperText={errors.dateOfDeath}
//           />
//         </Grid>
//         <Grid size={{ xs: 12, md: 4 }}>
//           <Input
//             fullWidth
//             label="Cause of Death *"
//             InputLabelProps={{ shrink: true }}
//             value={deceasedDetails.causeOfDeath}
//             onChange={(e: any) => {
//               setDeceasedDetails({ causeOfDeath: e.target.value });
//               clearError("causeOfDeath");
//             }}
//             error={Boolean(errors.dateOfDeath)}
//             helperText={errors.dateOfDeath}
//           />
//         </Grid>

//         <Grid size={{ xs: 12, md: 6 }} mt={1.8}>
//           <Input
//             select
//             fullWidth
//             label="Relationship to Informant"
//             variant="outlined"
//             value={deceasedDetails.relationship}
//             onChange={(e: any) =>{
//               setDeceasedDetails({ relationship: e.target.value });
//               clearError("relationship")
//             }
//             }
//             error={Boolean(errors.relationship)}
//             helperText={errors.relationship}
//             SelectProps={{
//               displayEmpty: true,
//               renderValue: (selected: any) =>
//                 selected ? (
//                   selected
//                 ) : (
//                   <span style={{ color: "#aaa" }}>Select Relationship</span>
//                 ),
//               MenuProps: {
//                 PaperProps: {
//                   sx: {
//                     backgroundColor: "#ffffff",
//                     borderRadius: "12px",
//                     maxHeight: "300px",
//                   },
//                 },
//               },
//             }}
//           >
//             {loading ? (
//               <MenuItem disabled>Loading relationships...</MenuItem>
//             ) : (
//               relationOptions.map((relation: string, index) => (
//                 <MenuItem
//                   key={index}
//                   value={relation}
//                   sx={{
//                     background: "background.default",
//                     borderBottom: `1px solid ${theme.palette.grey[200]}`,
//                   }}
//                 >
//                   {relation}
//                 </MenuItem>
//               ))
//             )}
//           </Input>
//         </Grid>
//         <Grid size={{ xs: 12, md: 6 }}>
//           <RadioGroup
//             row
//             name="passport"
//             value={deceasedDetails.identificationType}
//             onChange={(e) => {
//               setDeceasedDetails({ identificationType: e.target.value });
//               clearError("identificationType");
//             }}
//           >
//             <FormControlLabel value="id" control={<Radio />} label="ID" />
//             <FormControlLabel
//               value="passport"
//               control={<Radio />}
//               label="Passsport"
//             />
//           </RadioGroup>
//           <Input
//             fullWidth
//             variant="outlined"
//             placeholder={
//               deceasedDetails.identificationType === "passport"
//                 ? "Passport Number"
//                 : "ID Number"
//             }
//             value={deceasedDetails.identificationNumber}
//             onChange={(e: any) => {
//               const value = e.target.value;
//               setDeceasedDetails({ identificationNumber: value });
//               clearError("identificationNumber");

//                 if (deceasedDetails.identificationType === "id") {
//                   const error = validateSouthAfricanID(value);
//                   setErrors((prev: any) => ({
//                     ...prev,
//                     identificationNumber: error || "",
//                   }));
//                 } else {
//                   setErrors((prev: any) => {
//                     const newErrors = { ...prev };
//                     delete newErrors.identificationNumber;
//                     return newErrors;
//                   });
//                 }
//             }}
//             error={Boolean(errors.identificationNumber)}
//             helperText={errors.identificationNumber}
//           />
//         </Grid>
//       </Grid>

//       {/* Buttons */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           mt: 5,
//         }}
//       >
//         <ButtonComp variant="outlined" height={40} width={190} onClick={onBack}>
//           Back
//         </ButtonComp>

//         <ButtonComp
//           variant="contained"
//           height={40}
//           width={190}
//           onClick={handleNextClick}
//         >
//           Next
//         </ButtonComp>
//       </Box>
//     </Paper>
//   );
// }

import { useCaseCreationStore } from "../../../../store/useCaseCreationStore";
import { useQuotationCreationStore } from "../../../../store/useQuotationCreationStore";
import DeceasedDetailsForm from "../../components/forms/DeceasedDetailsForm";


export default function DeceasedDetails({ onNext, onBack, minimalCapture = false }: any) {

  const { deceasedDetails, setDeceasedDetails } = useCaseCreationStore();

  return (
    <DeceasedDetailsForm
      deceasedDetails={deceasedDetails}
      setDeceasedDetails={setDeceasedDetails}
      onNext={onNext}
      onBack={onBack}
      minimalCapture={minimalCapture}
    />
  );
}
